<template>
  <div>
  <blue-panel>
    <div id="date-time-picker">
      <div id="info-label">{{ $t('lbl.selectTimePeriod') }}</div>
      <label id="from-label" for="start-date">{{ $t('lbl.from') }} </label>
      <input id="start-date" type="date" v-model="startDate">
      <input id="start-time" type="time" v-model="startTime">
      <span id="dash"> &nbsp;-&nbsp; </span>
      <label id="to-label" for="end-date">{{ $t('lbl.to') }} </label>
      <input id="end-date" type="date" v-model="endDate">
      <input id="end-time" type="time" v-model="endTime">
      <span class="buttons">
      <input id="process-button" :value="$t('btn.apply')" type="submit" name="date-range" @click="onApply">
    </span>
    </div>
  </blue-panel>
    <div id="submenu">
      <div class="item ">
        <a @click="onTodayClick">За сегодня</a>
      </div>
      <div class="item ">
        <a @click="onYesterdayClick">Вчера</a>
      </div>
    </div>
  </div>
</template>

<script>
  function convertTimestampToInputDate(timestamp) {
    const date = new Date(timestamp);
    let format = `${date.getFullYear()}`;
    const month = date.getMonth() + 1;
    if (month.toString().length === 1) {
      format += `-0${month}`;
    } else {
      format += `${month}`;
    }
    const day = date.getDate();
    if (day.toString().length === 1) {
      format += `-0${day}`;
    } else {
      format += `-${day}`;
    }
    return format;
  }
  function convertTimestampToInputTime(timestamp) {
    let format = '';
    const date = new Date(timestamp);
    const hours = date.getHours();
    if (hours.toString().length === 1) {
      format += `0${hours}`;
    } else {
      format += `${hours}`;
    }
    const minutes = date.getMinutes();
    if (minutes.toString().length === 1) {
      format += `:0${minutes}`;
    } else {
      format += `:${minutes}`;
    }
    const seconds = date.getSeconds();
    if (seconds.toString().length === 1) {
      format += `:0${seconds}`;
    } else {
      format += `:${seconds}`;
    }
    return format;
  }
  function convertInputDateTimeToTimestamp(inputDate, inputTime) {
    const ds = inputDate.split('-');
    const ts = inputTime.split(':');
    const year = parseInt(ds[0], 10);
    const monthIndex = parseInt(ds[1], 10) - 1;
    const day = parseInt(ds[2], 10);
    const hours = parseInt(ts[0], 10);
    const minutes = parseInt(ts[1], 10);
    const seconds = parseInt(ts[2], 10);
    return new Date(year, monthIndex, day, hours, minutes, seconds, 0).getTime();
  }
  export default {
    name: "BluePanelDateTimePicker",
    data() {
      return {
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null,
      }
    },
    methods: {
      onTodayClick() {
        this.$emit('todayClicked');
      },
      onYesterdayClick() {
        this.$emit('yesterdayClicked');
      },
      onApply() {
        this.$emit('apply', {
          min: convertInputDateTimeToTimestamp(this.startDate, this.startTime),
          max: convertInputDateTimeToTimestamp(this.endDate, this.endTime),
        });
      }
    },
    created() {
      const min = Date.now() - 24 * 60 * 60 * 1000;
      const max = Date.now();
      this.startDate = convertTimestampToInputDate(min);
      this.startTime = convertTimestampToInputTime(min);
      this.endDate = convertTimestampToInputDate(max);
      this.endTime = convertTimestampToInputTime(max);
      console.log(this.endDate);
      console.log(this.startDate);
    }
  }
</script>

<style scoped>
  #date-time-picker {
    font-size: 100%;
    font-style: normal;
    color: #000;
  }
  #info-label {
    color: #666;
    font-size: 11px;
    margin-bottom: 2px;
    padding: 0;
    border: 0;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
  }
  #from-label {
    color: #666;
    font-size: 11px;
    margin-bottom: 2px;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
    text-align: left;
  }
  #start-date {
    font-size: 12px;
    font-family: Arial,serif;
    border: 1px solid #d1d1d1;
    background: #fff;
    color: #333;
    padding: 2px 4px;
    height: 14px;
    width: 120px;
    margin: 0 2px 0 0;
    -webkit-appearance: textfield;
    -webkit-rtl-ordering: logical;
    cursor: text;
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    -webkit-writing-mode: horizontal-tb !important;
    writing-mode: horizontal-tb !important;
  }
  #start-time {
    font-size: 12px;
    font-family: Arial,serif;
    border: 1px solid #d1d1d1;
    background: #fff;
    color: #333;
    padding: 2px 4px;
    height: 14px;
    width: 105px;
    margin: 0px 2px 0px 0px;
    -webkit-rtl-ordering: logical;
    cursor: text;
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    -webkit-writing-mode: horizontal-tb !important;
    writing-mode: horizontal-tb !important;
  }
  #dash {
    color: #666;
    font-size: 11px;
    margin-bottom: 2px;
  }
  #to-label {
    color: #666;
    font-size: 11px;
    margin-bottom: 2px;
    padding: 0;
    border: 0;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
  }
  #end-date {
    font-size: 12px;
    font-family: Arial, sans-serif;
    border: 1px solid #d1d1d1;
    background: #fff;
    color: #333;
    padding: 2px 4px;
    height: 14px;
    width: 120px;
    margin: 0px 2px 0px 0px;
    -webkit-rtl-ordering: logical;
    cursor: text;
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    -webkit-writing-mode: horizontal-tb !important;
    writing-mode: horizontal-tb !important;
  }
  #end-time {
    font-size: 12px;
    font-family: Arial, sans-serif;
    border: 1px solid #d1d1d1;
    background: #fff;
    color: #333;
    padding: 2px 4px;
    height: 14px;
    width: 105px;
    margin: 0 2px 0 0;
    -webkit-appearance: textfield;
    -webkit-rtl-ordering: logical;
    cursor: text;
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    -webkit-writing-mode: horizontal-tb !important;
    writing-mode: horizontal-tb !important;
  }
  .buttons {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 12px;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
    text-align: left;
    font-family: Verdana, sans-serif;
    color: #000;
  }
  #process-button {
    font-size: 11px;
    border-radius: 4px;
    line-height: 18px;
    height: 20px;
    margin-right: 15px;
    padding: 0 10px;
    background-color: #eeeeee !important;
    color: #282828 !important;
    text-shadow: 0 1px 0px rgba(255, 255, 255, 0.8);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 1);
    background-image: -webkit-linear-gradient(top, #eeeeee, #e1e1e1);
    background-repeat: repeat-x;
    border: 1px solid #d9d8d8;
    border-color: #d9d8d8 #cccbcb #aeaeae;
    transition-duration: 0.2s;
    user-select: none;
    cursor: pointer;
    font-family: arial, sans-serif;
    font-weight: normal;
    text-decoration: none;
    display: inline-block;
    vertical-align: middle;
    align-items: flex-start;
    text-align: center;
    box-sizing: border-box;
    -webkit-appearance: push-button;
    white-space: pre;
    -webkit-rtl-ordering: logical;
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0;
    -webkit-writing-mode: horizontal-tb !important;
    outline: none;
  }
  #process-button:hover {
    font-size: 11px;
    border-radius: 4px;
    line-height: 18px;
    height: 20px;
    background-color: #fcfcfc !important;
    background-image: -webkit-linear-gradient(top, #fcfcfc, #e8e8e8);
    background-repeat: repeat-x;
    text-decoration: none;
    margin-right: 15px;
    padding: 0 10px;
    color: #282828 !important;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.8);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 1);
    border: 1px solid #d9d8d8;
    border-color: #d9d8d8 #cccbcb #aeaeae;
    transition-duration: 0.2s;
    user-select: none;
    cursor: pointer;
    font-family: arial, sans-serif;
    font-weight: normal;
    display: inline-block;
    vertical-align: middle;
    /* margin: 0; */
    align-items: flex-start;
    text-align: center;
    box-sizing: border-box;
    -webkit-appearance: push-button;
    white-space: pre;
    -webkit-rtl-ordering: logical;
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0;
    /* font: 400 11px system-ui; */
    -webkit-writing-mode: horizontal-tb !important;
  }
  #process-button:active {
    font-size: 11px;
    border-radius: 4px;
    line-height: 18px;
    height: 20px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.2);
    background: #e1e1e1 !important;
    border: 1px solid #a4a7ac;
    border-color: #a4a7ac #d2d3d4 #e1e1e1;
    text-shadow: 0 1px 1px rgba(255, 255, 255, 0.5);
    margin-right: 15px;
    padding: 0px 10px;
    color: #282828 !important;
    transition-duration: 0.2s;
    user-select: none;
    cursor: pointer;
    font-family: arial, sans-serif;
    font-weight: normal;
    text-decoration: none;
    display: inline-block;
    vertical-align: middle;
    align-items: flex-start;
    text-align: center;
    box-sizing: border-box;
    -webkit-appearance: push-button;
    white-space: pre;
    -webkit-rtl-ordering: logical;
    text-rendering: auto;
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0;
    -webkit-writing-mode: horizontal-tb !important;
  }
  #submenu {
    float: left;
    overflow: hidden;
    padding: 0 3px;
    background: #d3e2f0;
    color: #666666;
    margin-right: 1px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border: 0;
    font-size: 12px;
    font-style: normal;
    outline: 0;
    display: block;
    text-align: left;
    font-family: Verdana, sans-serif;
  }
  .item {
    float: left;
    padding: 6px 7px;
    margin: 0;
    font-size: 12px;
    font-style: normal;
    outline: 0;
    display: block;
    color: #666666;
    text-align: left;
    font-family: Verdana, sans-serif;
  }
  a {
    color: #666666;
    text-decoration: underline;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 12px;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
    cursor: pointer;
    text-align: left;
    font-family: Verdana, sans-serif;
  }
  a:hover {
    color: #a3a3a3;
  }
</style>

